import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {KfChartsService} from '../../../../services/kf-charts.service';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../../utils/filters-utils';
import {ActivatedRoute, Router} from '@angular/router';
import {VctCollectedChartData} from '../../../../models/vct-collected-chart-data.interface';

@Component({
  selector: 'app-vctp-from',
  templateUrl: './vctp-from.component.html',
  styleUrls: ['./vctp-from.component.scss']
})
export class VctpFromComponent implements OnInit {

  text!: string;
  subtitle = '';
  data!: VctCollectedChartData[];
  displayUnits = 'ABSOLUTE';
  years!: number[];
  yearSelected!: number;
  search!: ChartsSearchInterface;

  constructor(private readonly kfChartsService: KfChartsService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute,
              private readonly changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.loadYears();
    this.loadSearch();
  }

  loadSearch(){
    this.activatedRoute.queryParams.subscribe((params) => {
      this.search = getFiltersFromQueryParams(params);
      if(this.years && this.search){
        this.loadData();
      }
    });
  }

  loadData(){
    //this.years.unshift(this.years[0] + 1);
    if (!this.search.startYear) {
      this.search.startYear =  this.years[0];
      this.yearSelected = this.years[0];
    }
    if (!this.search.order) {
      this.search.order = 'alph';
    }
    this.text = 'European collection target performance, ' + this.search.startYear;
    this.subtitle = '65% of Average Market input ' + (this.search.startYear - 3) + ' - ' + (this.search.startYear - 1) + ' (kg/inhabitant)';
    this.loadVCTP(this.search, this.years);
  }

  loadYears(){
    this.kfChartsService.getYears('collected', 'COUNTRY_SCHEMA')
    .subscribe(data => {
      this.years = data;
      if(this.years && this.search){
        this.loadData();
      }
    });
  }

  loadVCTP(search:ChartsSearchInterface, data:number[]){
    this.kfChartsService.getVCTPFrom(search)
    .subscribe(response => {
      this.data = response;
      this.loadVCTPSecondYear(search,data);
      this.changeDetectorRef.detectChanges();
    });
  }

  loadVCTPSecondYear(search:ChartsSearchInterface, data:number[]){
    if (this.data?.length == 0 || this.data == undefined) {
      search.startYear = data[1];
      this.kfChartsService.getVCTPFrom(search)
      .subscribe(response => {
        this.data = response;
        this.yearSelected = data[1];
        this.text = 'European collection target performance, ' + search.startYear;
        this.subtitle = '65% of Average Market input ' + (data[1] - 3) + ' - ' + (data[1] - 1) + ' (kg/inhabitant)';
        this.searchData(search);
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  searchData(event: ChartsSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});

    if (event.displayUnits && event.displayUnits !== '') {
      this.displayUnits = event.displayUnits;
    }
  }

}
